import { css } from '@emotion/react';
import styled from '@emotion/styled';
import React, { ComponentProps } from 'react';
import { IconArrowRight16 } from 'components/base/Icon';
import Link from 'components/base/Link';
import Text from 'components/base/Text';
import { gray100, gray500 } from 'styles';
import { WebViewType } from 'util/app_utils';

interface Props {
  title: string;
  title_style?: ComponentProps<typeof Text>;
  description?: string;
  description_style?: ComponentProps<typeof Text>;
  classname?: string;
  show_bottom_line?: boolean;
  webview_type?: WebViewType;
  show_new_webview?: boolean;
  show_new_webview_for_legacy?: boolean;
  href?: string;
  onMenuClick?: () => void;
}

/**
 * 마이페이지 [메인] - 메뉴 리스트 아이템
 * @component
 */
const MenuItem: React.FC<Props> = ({
  title,
  title_style = { variant: 'title5_medium', color: 'gray900' },
  description,
  description_style = { variant: 'small1_regular', color: 'gray500' },
  show_bottom_line = false,
  show_new_webview = true,
  show_new_webview_for_legacy = false,
  webview_type = 'full',
  classname,
  onMenuClick,
  href,
}) => {
  const href_props = href ? { href, show_new_webview_for_legacy, show_new_webview } : {};

  return (
    <SC.Container className={classname} show_bottom_line={show_bottom_line}>
      <SC.Item onClick={onMenuClick} {...href_props} classname='menu_item' webview_type={webview_type}>
        <SC.MenuInfo className='menu_info'>
          <Text {...title_style} className='title'>
            {title}
          </Text>
          {description && (
            <Text {...description_style} className='description'>
              {description}
            </Text>
          )}
        </SC.MenuInfo>
        <IconArrowRight16 width={20} height={20} color={gray500} />
      </SC.Item>
    </SC.Container>
  );
};

export default MenuItem;

const menu_item_css = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
  cursor: pointer;
`;

const SC = {
  Container: styled.div<{ show_bottom_line?: boolean }>`
    width: 100%;
    ${({ show_bottom_line }) => show_bottom_line && `border-bottom: 1px solid ${gray100};`}
    .menu_item {
      ${menu_item_css};
    }
  `,
  Item: styled(Link)`
    ${menu_item_css};
  `,
  MenuInfo: styled.div`
    width: 100%;
    padding-right: 6px;
    display: flex;
  `,
};
